module.exports = __webpack_public_path__ + "img/ALL.fd6cdfa5.svg";